import './App.css'; 
import { BrowserRouter, Routes, Route, useNavigate, useParams, Navigate, useLocation } from 'react-router-dom';
import Start from './Component/Start/Start';
import SetUpReady from './Component/SetUpReady/SetUpReady';
import Notifications from './Component/Notifications/Notifications';
import TrialOffer from './Component/TrialOffer/TrialOffer';
import BuildPlan from './Component/BuildPlan/BuildPlan';
import SignUp from './Component/SignUp/SignUp';
import Details from './Component/Details/Details';
import Step from './Component/Step/Step';
import SubscriptionPlan from './Component/SubscriptionPlan/SubscriptionPlan';
import AboutBusiness from './Component/AboutBusiness/AboutBusiness';
import BusinessDetails from './Component/BusinessDetails/BusinessDetails';
import 'react-toastify/dist/ReactToastify.css';
import AgentDetail from './Component/AgentDetails/AgentDetail';
import AiAssistant from './Component/AiAssistant/AiAssistant';
import BusinessLocation from './Component/BusinessLocation/BusinessLocation';
import SecureRoute from './Pages/SecureRoute';
import Dashboard from './Component/Dashboard/Dashboard';
import RexAgent from './Component/RexAgent/RexAgent';
import Plans from './Component/Plans/Plans';
import MessagePlan from './Component/MessagePlan/MessagePlan';
import Delete from './Component/Delete/Delete';
import SubscriptionFlow from './Component/Checkout/SubscriptionFlow';
import Calendar from './Component/Celender/Calendar';
import BusinessServices from './Component/BusinessServices/BusinessServices';
import TotalsCallsList from './Component/TotalsCallsList/TotalsCallsList';
import CallTransfer from './Component/CallTransfer/CallTransfer';
import CallDetails from './Component/CallDetails/CallDetails';
import LiveMonitoringDashboard from './Component/LiveMonitoring/LiveMonitoringDashboard';
import ActiveCallsList from './Component/LiveMonitoring/ActiveCallsList';
import BusinessServicesNEXT from './Component/BusinessServices/BusinessServicesNEXT';
import CalInfo from './Component/Dashboard/CalInfo';
import EditProfile from './Component/EditProfile/EditProfile';
//... Edit Screen Start ....//
import EditAgentNew from './Component/EditAgentNew/EditAgentNew';
import EditBusinessType from './Component/EditBusinessType/EditBusinessType';
import EditServicesOffered from './Component/EditServicesOffered/EditServicesOffered';
import EditPublic from './Component/EditPublic/EditPublic';
import EditBusinessDetail from './Component/EditBusinessDetail/EditBusinessDetail';
import EditLanguage from './Component/EditLanguage/EditLanguage';
import EditGender from './Component/EditGender/EditGender';
import EditNameAvtar from './Component/EditNameAvtar/EditNameAvtar';
//////... Editt Screen End ....//
import { useEffect, useState } from "react";
import RoutePersistence from "./Component/RoutePersistence/RoutePersistence";
import WidgetGuidePage from "./Component/WidgetGuidePage/WidgetGuidePage";
import BusinessListing from "./Component/BusinessListing/BusinessListing";
import Test from "./utils/Test";
import CallSetting from "./Component/CallSetting/CallSetting";
import PublicAgentAvailability from "./Component/PublicAgentAvailability/PublicAgentAvailability";
import ConnectCalenderAPI from "./Component/ConnectCalenderAPI/ConnectCalanderAPI";
import AssignNumber from "./Component/AssignNumber/AssignNumber";
import PaymentSuccess from "./Component/PaymentSuccess/PaymentSuccess";
import RouteTracker from "./Component/RouteTracker/RouteTracker";
import Thankyou from "./Component/ThankyouPage/Thankyou";
import CancelPage from "./Component/CancelPage/CancelPage";
import IntegrateAgent from "./Component/Integrate-agent/Integrate-agent";
import AgentSetupHelp from "./Component/AgentSetupHelp/AgentSetupHelp";
import Plan from "./Component/Plans/Plans";
import Planss from "./Component/Plan/Plan";
import Documentation from "./Component/Documentation/Documentation";
import RedirectHandler from "./utils/RedirectHandler ";
import PreventPullToRefresh from "./Component/PreventPullToRefresh/PreventPullToRefresh";
import Thankyou2 from "./Component/ThankyouPage2/Thankyou2";
import WebsiteTrialSuccess from "./Component/WebsiteTrialSuccess/WebsiteTrialSuccess";
import PostPurchaseSetup from "./Component/PostPurchaseFlow/PostPurchaseSetup";
import GoLiveWizard from "./Component/GoLiveWizard/GoLiveWizard";
import ContactSyncStep from "./Component/ContactSyncStep/ContactSyncStep";
import ScreenCallsIntro from "./Component/ScreenCallsIntro/ScreenCallsIntro";
import CalendarBookingIntro from "./Component/CalendarBookingIntro/CalendarBookingIntro";
import GoLiveCelebration from "./Component/GoLiveCelebration/GoLiveCelebration";
import Number from "./Component/assign/Number";
import CallRecording from "./Component/CallRecording/CallRecording";
import RaiseTickets from "./Component/Tickets/RaiseTickets";
import CreateTicketModal from "./Component/Tickets/CreateTicketModal";
import CreateTicket from "./Component/Tickets/CreateTicket";
import Fileinfo from "./Component/AgentDetails/FileInfo/Fileinfo";
import ForcePortraitOnly from "./utils/ForcePortraitOnly";
import decodeToken from "./lib/decodeToken";
import { initNotificationSocket, registerPushToken, setupNativeMessageBridge, syncStoredPushToken } from "./utils/initNotificationSocket";
import PushPermissionModal from "./Component/PushPermissionModal/PushPermissionModal";
import { checkAgentExistence, getUserNotifications, getAgentsByUserIdforkey, getUserDetails, setContactOwnerId } from "./Store/apiStore";
import { fireAuthEvent, isAuthEventRecorded, setGAUser } from "./lib/analytics";
import { GlobalCallProvider } from "./contexts/GlobalCallContext";
import GlobalCallBanner from "./Component/GlobalCallBanner/GlobalCallBanner";
import LiveCallStrip from "./Component/LiveCallStrip/LiveCallStrip";
import CallRouteGuide from "./Component/CallRouteGuide/CallRouteGuide";
import GlobalOfferModal from "./Component/GlobalOfferModal/GlobalOfferModal";
// .//io import removed — socket is handled by initNotificationSocket
import { useNotificationStore } from "./Store/notificationStore";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import NotificationView from "./Component/Notifications/NotificationView";
import NeedHelpTicketsPage from "./Component/NeedHelpModal/NeedHelpTicketsPage"; // ADDED
import IntegrationThankYou from "./Component/IntegrationSuccess/IntegrationThankYou";
import OwnPlan from "./Component/OwnPlan/OwnPlan";
import CustomPlan from "./Component/BuildPlan/CustomPlan";
import PublicWidgetPage from "./Component/PublicWidgetPage/PublicWidgetPage"
import { loadGoogleMapsGlobally } from "./utils/loadGoogleMaps";
import Add_VIP_Number from "./Component/AgentDetails/Vip_number/Add_VIP_Number";
import PublicCall from "./Component/Public_call";
import Onboarding from "./Component/Onboarding/Onboarding";
import ForkScreen from "./Component/ForkScreen/ForkScreen";
import SelectAccess from "./Component/AccessPicker/SelectAccess";
import { primeContext, needsAccessPicker } from "./lib/activeContext";
import BusinessStep from "./Component/BusinessStep/BusinessStep";
import PounceAgentDetail from "./Component/PounceAgentDetail/PounceAgentDetail";
import AppSumoRedeemPage from "./Component/AppSumoRedeem/AppSumoRedeemPage";
import PounceAddLeadPage from "./Component/PounceAddLeadPage/PounceAddLeadPage";
import PounceBulkUploadPage from "./Component/PounceBulkUploadPage/PounceBulkUploadPage";
import PounceBulkUploadReviewPage from "./Component/PounceBulkUploadReviewPage/PounceBulkUploadReviewPage";
import PounceBulkUploadSuccessPage from "./Component/PounceBulkUploadSuccessPage/PounceBulkUploadSuccessPage";
import PounceLeadsPage from "./Component/PounceLeadsPage/PounceLeadsPage";
import OutboundSettings from "./Component/OutboundSettings/OutboundSettings";
import OutboundBilling from "./Component/OutboundBilling/OutboundBilling";
import OutboundInvoices from "./Component/OutboundInvoices/OutboundInvoices";
import PounceLeadDetail from "./Component/PounceLeadsPage/PounceLeadDetail/PounceLeadDetail";
import PounceCallTranscript from "./Component/PounceLeadsPage/PounceLeadDetail/PounceCallTranscript";
import PounceLeadActivity from "./Component/PounceLeadsPage/PounceLeadDetail/PounceLeadActivity";
import DashboardSkeleton from "./Component/Dashboard/DashboardSkeleton/DashboardSkeleton";
import PounceAppointmentsPage from "./Component/PounceAppointments/PounceAppointmentsPage";
import PounceAppointmentDetail from "./Component/PounceAppointments/PounceAppointmentDetail";
import RewardsHome from "./Component/Rewards/RewardsHome";
import ReferralsEarnings from "./Component/Rewards/ReferralsEarnings";
import GiveFeedback from "./Component/Rewards/GiveFeedback";
import Earnings from "./Component/Rewards/Earnings";
import FastSetup from "./Component/FastSetup/FastSetup";
import { captureOAuth } from "./lib/integrationOAuth";
import { captureVariantOverride } from "./lib/experiments";
import GetNumber from "./Component/GetNumber/GetNumber";
import NumberAssign from "./Component/NumberAssign/NumberAssign";
import ImmediateOwnerShip from "./Component/ImmediateOwnerShip/ImmediateOwnerShip";
// A/B variant B ka naya post-"Go Live" flow. Variant A (/recommended-plan) ko
// ye screens kabhi nahi chhutin — dono raste alag components me hain.
import ReceptionistNumber from "./Component/BFlow/ReceptionistNumber/ReceptionistNumber";
import AgentLive from "./Component/BFlow/AgentLive/AgentLive";
import CallSummary from "./Component/BFlow/CallSummary/CallSummary";
import BflowReturnGuard from "./Component/BFlow/BflowReturnGuard";
import SetupPath from "./Component/BFlow/SetupPath/SetupPath";
import PaymentCancel from "./Component/PaymentCancel/PaymentCancel";
import SelectCarrier from "./Component/SelectCarrier/SelectCarrier";
import ForwardInstructions from "./Component/ForwardInstructions/ForwardInstructions";
import FastAgentDetails from "./Component/FastAgentDetails/FastAgentDetails";
import TheComparison from "./Component/TheComparison/TheComparison";
import TheSolution from "./Component/TheSolution/TheSolution";
import RecommendedPlan from "./Component/RecommendedPlan/RecommendedPlan";
import Business_hours from "./Component/Business_Hours/Business_hours";
import AgentSchedule from "./Component/AgentSchedule copy/AgentSchedule";
import EditBusinessDetails from "./Component/BusinessStep/Editbusinessdetails";
import CallDivert from "./Component/CallDivert/CallDivert";
import ConnectCalenderV2 from "./Component/ConnectCalenderV2/ConnectCalenderV2";
import useImpersonation from "./hooks/useImpersonation";
import ContactsPage from "./Component/ContactsPage/ContactsPage";
import UsageHistory from "./Component/UsageHistory/UsageHistory";
import ManageSubscription from "./Component/ManageSubscription/ManageSubscription";
import IntegrationsPage from "./Component/Integrations/IntegrationsPage";
import McpIntegration from "./Component/McpIntegration/McpIntegration";
import Dialer from "./Component/Dialer/Dialer";
import Loader from "../src/Component/Loader/Loader";
import { io } from 'socket.io-client';
import CheckoutSheet from "./Component/CheckoutSheet/CheckoutSheet";
import ErrorBoundary from "./Component/ErrorBoundary/ErrorBoundary";
import ImportPhoneSip from "./Component/ImportPhoneSip/ImportPhoneSip";
import PounceSettings from './Component/PounceSettings/PounceSettings';
import PounceQualifyingQuestions from './Component/PounceQualifyingQuestions/PounceQualifyingQuestions';
// import Test from "./utils/Test";
function App() {
  useImpersonation();
  const [refreshKey, setRefreshKey] = useState(0);
  const token = localStorage.getItem('token');
  const lastRoute = localStorage.getItem('lastVisitedRoute');
  const decoded = decodeToken(token);
  const userID = decoded?.id;
  const isTeamMember = !!localStorage.getItem("teamOwnerId");
  // SOCKET_URL removed — socket is handled by initNotificationSocket
  const SOCKET_URL = process.env.REACT_APP_API_BASE_URL?.split('/api')[0];
  const notifications = useNotificationStore((state) => state.notifications);
  const addNotification = useNotificationStore((state) => state.addNotification);
  const loadNotifications = useNotificationStore((state) => state.loadNotifications);
  const toggleFlag = useNotificationStore((state) => state.toggleFlag);
  const [unreadCount, setUnreadCount] = useState(0);

  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [confirmPopup, setConfirmPopup] = useState(false);
  // const [refreshNotification,setRefreshNoitification]=useState(false)
  const navigate = useNavigate();
  const location = useLocation();
  const [agentCode, setAgentCode] = useState(null);
  const [renderStatusPage, setRenderStatusPage] = useState(false);
  const [isChecking, setIsChecking] = useState(true);
  const [has1Agents, sethas1Agents] = useState(false);
  // Real number of the user's own agents (from getAgentsByUserIdforkey). Used
  // by the /signup return-visit redirect so single-agent users always land on
  // /fast-agent-detail — never /dashboard — matching every other entry point.
  const [agentCount, setAgentCount] = useState(null);
  const [loadingAgents, setLoadingAgents] = useState(true);
  // ── Integration OAuth: capture redirect_uri + state on entry ─────────
  // Global safety net: if a provider's popup lands on ANY page carrying its
  // OAuth params (not just /oauth/:platform/consent), persist them into cookies
  // so they survive login → onboarding until /fast-step closes the loop.
  // See lib/integrationOAuth.js for why cookies (localStorage.clear survival).
  useEffect(() => {
    primeContext(setContactOwnerId);
    captureOAuth(window.location.search);
    // QA-only: ?ab=B (ya ?ab=A) URL me ho to us variant ko chipka do, taaki
    // backend wiring se pehle bhi dono flows walk kiye ja sakein. Real users ke
    // URL me ye param kabhi nahi hota, isliye production pe koi asar nahi.
    captureVariantOverride(window.location.search);
  }, []);
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'token' && e.newValue !== e.oldValue) {
        // Token change hua — purana sessionStorage stale hai
        sessionStorage.clear();
        window.location.reload(); // Fresh data fetch hoga
      }
    };

    window.addEventListener('storage', (e) => handleStorageChange(e));
    return () => window.removeEventListener('storage', (e) => handleStorageChange(e));
  }, []);
  // ── Surface-agnostic sign_up / login catch-all ───────────────────────
  // Web: the token arrives as ?token= and SignUp / Onboarding fire the event
  // with the real method (google / email). This detector skips that case.
  //
  // Native app: chatkefun() posts GOOGLE_SIGN_IN to the shell, the shell runs
  // OAuth in an InAppBrowser, and then hands the JWT back. The web side has NO
  // login-SUCCESS bridge — the only RN message the login screens listen for is
  // OAUTH_CANCELLED. So when the shell drops the token into localStorage
  // without navigating the WebView, nothing re-renders: no route change, no
  // effect re-run, and sign_up / login never fired at all.
  //
  // Fix: watch for the TOKEN instead of waiting for a navigation. The check is
  // a localStorage read, so polling it is cheap; the network lookup only runs
  // when there is an unrecorded token. Also kicked on visibilitychange, which
  // is exactly when the user returns from the OAuth browser. Stops as soon as
  // the event is recorded.
  useEffect(() => {
    let cancelled = false;
    let inFlight = false;
    let id = null;

    const stop = () => {
      if (id) { clearInterval(id); id = null; }
    };

    const attempt = async () => {
      if (cancelled || inFlight) return;
      // Recorded → is session me aur kuch nahi karna, polling band.
      if (isAuthEventRecorded()) { stop(); return; }
      const t = localStorage.getItem("token");
      if (!t) return; // logged out — token aane ka intezaar karo
      // ?token= present → SignUp/Onboarding owns it and knows the real method.
      if (new URLSearchParams(window.location.search).get("token")) return;
      const uid = decodeToken(t)?.id;
      if (!uid) return;
      inFlight = true;
      try {
        const data = await getUserDetails(uid, t);
        if (cancelled) return;
        // getUserDetails returns response.data; the user may be data.user or data.
        const u = data?.user || data || {};
        setGAUser(uid);
        // method unknown at this layer (deep link doesn't carry it) → "app"
        fireAuthEvent({
          isExisting: u.verifyDetails === true,
          method: "app",
          token: t,
        });
      } catch {
        // Analytics must never break the app — swallow and let the next tick retry.
      } finally {
        inFlight = false;
      }
    };

    attempt();
    id = setInterval(attempt, 3000);
    const onVisible = () => { if (!document.hidden) attempt(); };
    document.addEventListener("visibilitychange", onVisible);

    return () => {
      cancelled = true;
      stop();
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);

  useEffect(() => {
    setupNativeMessageBridge();
    loadGoogleMapsGlobally();
  }, []);
  useEffect(() => {
    if (userID) {
      try {
        initNotificationSocket(userID, navigate);
        syncStoredPushToken(userID);
      } catch (err) {
        console.error('Token decode error:', err);
      }
    }
  }, [userID, navigate]);
  // custa
  useEffect(() => {
    if (userID) {
      getUserNotifications(userID)
        .then((resp) => {
          // console.log("user notifications ", resp);
          loadNotifications(resp?.notifications || []);
        })
        .catch((err) => console.log('error while fetching user Notifications', err));
    }
  }, [userID, token]);

  useEffect(() => {
    if (userID) {
      setLoadingAgents(true);

      getAgentsByUserIdforkey()
        .then((resp) => {
          // console.log('agents count:', resp.count);
          if (resp.count === 1 && resp.agent) {
            sessionStorage.setItem("SelectAgentId", resp.agent.agent_id);
            sessionStorage.setItem("SelectAgentBusinessId", resp.agent.businessId || "");
          }
          sethas1Agents(resp.count === 1);
          setAgentCount(parseInt(resp.count || 0, 10));
        })
        .catch((err) => console.log('error while fetching agents', err))
        .finally(() => setLoadingAgents(false));
    }
  }, [userID]);


  //  Logic

  useEffect(() => {
    const count = notifications?.filter((n) => n?.status === 'unread')?.length;
    setUnreadCount(count);
  }, [notifications]);

  // Socket connection is handled by initNotificationSocket above.
  // No duplicate socket needed here.
  useEffect(() => {
    if (!userID) return;
    // Socket connect
    const socket = io(SOCKET_URL, {
      transports: ['websocket'],
      // Login token: backend iske bina `register` nahi maanta (src/socket.js).
      auth: (cb) => cb({ token: localStorage.getItem('token') || '' }),
    });
    socket.on('connect', () => {
      socket.emit('register', userID);
    });
    //  Listen for notification
    socket.on('notification', (msg) => { });
    socket.on('disconnect', () => {
      // console.log(" Disconnected");
    });
    return () => {
      socket.disconnect();
    };
  }, [userID]);
  useEffect(() => {
    const ref = document.referrer;
    // console.log("Referrer URL:", ref);
    sessionStorage.removeItem('hideBannerThisSession');
  }, []);
  //"Network changed → refreshing app
  useEffect(() => {
    const refreshApp = () => {
      console.log('Network changed → refreshing app');
      window.location.reload();
    };
    window.addEventListener('online', refreshApp);
    window.addEventListener('offline', refreshApp);
    return () => {
      window.removeEventListener('online', refreshApp);
      window.removeEventListener('offline', refreshApp);
    };
  }, []);

  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;

    const handleSwMessage = (event) => {
      const url = event.data?.url;
      if (event.data?.type === 'NAVIGATE' && typeof url === 'string' && url.startsWith('/')) {
        navigate(url);
      }
    };

    navigator.serviceWorker.addEventListener('message', handleSwMessage);

    return () => {
      navigator.serviceWorker.removeEventListener('message', handleSwMessage);
    };
  }, [navigate]);
  return (
    <GlobalCallProvider>
      {/* <ForcePortraitOnly /> */}

      <div className="DesktopPlusMobile">
        {/* {showPopup && (
          <>
                     <div
              style={{
                width: "100%",
                background: "linear-gradient(90deg, #6524EB, #8139FF)",
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "10px 16px",
                zIndex: 9999,
                fontFamily: "Inter, sans-serif",
                flexWrap: "wrap",
                boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
                position: "relative",
              }}
            >
              <div style={{ fontSize: "15px", fontWeight: "500" }}>
                Add <strong>Rexpt</strong> to your Home Screen for a better
                experience!
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginTop: "6px",
                }}
              >
                <button
                  onClick={handleInstall}
                  style={{
                    background: "white",
                    color: "#6524EB",
                    border: "none",
                    borderRadius: "6px",
                    padding: "6px 14px",
                    fontWeight: "600",
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                >
                  Install
                </button>

                <button
                  onClick={() => setConfirmPopup(true)}
                  style={{
                    background: "transparent",
                    color: "white",
                    border: "none",
                    fontSize: "18px",
                    cursor: "pointer",
                    lineHeight: "1",
                  }}
                >
                  ✕
                </button>
              </div>
            </div>

        
            {confirmPopup && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  background: "rgba(0,0,0,0.6)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 10000,
                }}
              >
                <div
                  style={{
                    background: "white",
                    borderRadius: "12px",
                    padding: "20px",
                    width: "90%",
                    maxWidth: "320px",
                    textAlign: "center",
                    boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
                  }}
                >
                  <h3 style={{ color: "#4B1EE5", marginBottom: "10px" }}>
                    Hide Install Banner?
                  </h3>
                  <p
                    style={{
                      color: "#555",
                      fontSize: "14px",
                      marginBottom: "20px",
                    }}
                  >
                    You can install Rexpt anytime later from your browser menu.
                  </p>

                  <div style={{ display: "flex", gap: "10px" }}>
              
                    <button
                      onClick={() => {
                        sessionStorage.setItem("hideBannerThisSession", "true");
                        setShowPopup(false);
                        setConfirmPopup(false);
                      }}
                      style={{
                        flex: 1,
                        background: "#f0f0f0",
                        color: "#333",
                        border: "none",
                        borderRadius: "6px",
                        padding: "10px 0",
                        fontWeight: "600",
                        cursor: "pointer",
                      }}
                    >
                      Hide for now
                    </button>

                
                    <button
                      onClick={() => {
                        localStorage.setItem("installPromptShown", "true");
                        setShowPopup(false);
                        setConfirmPopup(false);
                      }}
                      style={{
                        flex: 1,
                        background: "linear-gradient(90deg, #6524EB, #8139FF)",
                        color: "white",
                        border: "none",
                        borderRadius: "6px",
                        padding: "10px 0",
                        fontWeight: "600",
                        cursor: "pointer",
                      }}
                    >
                      Never Show Again
                    </button>
                  </div>
                </div>
              </div>
            )}
          </>
        )} */}

        <div className="ForDesktop">
          <img src="svg/Rexpt-Logo.svg" />
          <h1>
            Launch Your <b>AI Receptionist</b> with Rexpt.in
          </h1>
          <p>Launch Your AI Receptionist with Rexpt.in</p>
        </div>
        <div className="ForMobile">
          {/* <ForcePortraitOnly /> */}

          <PreventPullToRefresh setRefreshKey={setRefreshKey}>
            {/* <BrowserRouter> */}
            <div className="App" key={refreshKey}>
              {/* <RoutePersistence /> */}
              {/* Fires a GA4 screen_view on every SPA route change — the
                  flexible fallback funnel. Must sit inside the Router so
                  useLocation() works. */}
              <RouteTracker />
              {/* App-wide voice-call banner. Sits OUTSIDE <Routes> so it stays
                  mounted across navigation — the agent keeps talking and the
                  banner keeps showing. Renders nothing on web / when idle. */}
              <GlobalCallBanner />
              {/* Agent pe live call chal rahi ho to /fast-agent-detail pe strip. */}
              <LiveCallStrip />
              {/* Sales agent "select_offer('plans')" → plan picker over any screen. */}
              <GlobalOfferModal />
              {/* Stripe Embedded Checkout as an in-page bottom sheet. Also
                  OUTSIDE <Routes> so paying never changes the route — that is
                  what keeps the live call alive through checkout. */}
              <CheckoutSheet />
              {/* Route-aware guidance: while a call is live, inject a per-page
                  context note so the agent guides the user on each screen. */}
              <CallRouteGuide />
              {/* A/B variant B: dialer khol kar app kill karne wale user ko
                  agle cold boot par wapas /agent-live pe le aata hai (ek hi
                  baar — doosri baar wo dashboard hi jaayega). */}
              <BflowReturnGuard />
              {/* Any uncaught render error inside a route used to unmount the
                  whole tree and leave a blank white screen — invisible in dev
                  (CRA overlay catches it first) but exactly what QA saw in the
                  native WebView. The boundary shows the stack instead. */}
              <ErrorBoundary>
                <Routes>
                  {/* <Route
                  path="/signup"
                  element={
                    token ? (
                      <SecureRoute>
                        <Navigate to={"/dashboard"} />
                      </SecureRoute>
                    ) : (
                      <SignUp />
                    )
                  }
                /> */}

                  <Route
                    path="/signup"
                    element={
                      token &&
                        !new URLSearchParams(window.location.search).has("token") &&
                        // An AppSumo signup is mid-flight: the OTP stored a token,
                        // but the user still has to redeem their code before any of
                        // these destinations make sense. Without this the <Navigate>
                        // below fires during render and beats SignUp's own
                        // navigate() to the redeem route. AppSumoRedeemPage clears
                        // the flag once the user redeems or skips.
                        localStorage.getItem("appsumoRedeemPending") !== "true" ? (
                        loadingAgents ? (
                          <Loader size="30" />
                        ) : (
                          // Route by the REAL agent count (not just the token role):
                          //   1 agent  → /fast-agent-detail (always, even admins)
                          //   2+ agents → /dashboard
                          //   0 agents → admins/owners see the team dashboard, else home
                          <Navigate to={
                            // Multi-access users must pick a context FIRST — the agent
                            // count below is meaningless until they have. This guard
                            // re-renders the instant a token lands in localStorage, so
                            // without the check it beat the login screen’s own
                            // navigate("/select-access") and dropped the user straight
                            // onto /fast-agent-detail.
                            needsAccessPicker(decoded)
                              ? "/select-access"
                              : agentCount === 1
                                ? "/fast-agent-detail"
                                : (agentCount > 1 || ((agentCount === 0 || agentCount === null) && (decoded?.isTeamAdmin || decoded?.role === "admin")))
                                  ? "/dashboard"
                                  : "/business-step"
                          } />
                        )
                      ) : (
                        <SignUp />
                      )
                    }
                  />
                  {/* <Route
                  path="/"
                  element={

                    <Start />

                  }
                /> */}
                  {/*
                  /dashboard route re-enabled as the multi-agent picker.
                  Background:
                    - Earlier this redirected to /fast-agent-detail
                      (the consolidated home page for single-agent users).
                    - Users with 2+ agents got stuck in a loop:
                        /fast-agent-detail → no SelectAgentId in session →
                        navigate to /fork → ForkScreen had no "pick
                        existing agent" path → user creates yet another
                        agent OR refreshes and the loop continues.
                    - Re-enabling Dashboard gives multi-agent users a
                      proper "select which agent" surface. Single-agent
                      users still default to /fast-agent-detail because
                      ForkScreen and FastAgentDetails only route here
                      when they detect multiple agents.
                */}
                  <Route
                    path="/dashboard"
                    element={
                      // optimistic: token verify ka intezaar nahi — header, footer
                      // aur cards turant dikhte hain, taaki lautne par page
                      // "reload" na lage. Fallback sirf tab jab koi redirect
                      // lagne wala ho.
                      <SecureRoute optimistic fallback={<DashboardSkeleton />}>
                        {/* Multi-owner: team members now use the grouped Dashboard
                          (agents from every owner who added them), so they are
                          no longer redirected to the single-agent home. */}
                        <Dashboard />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/build-plan"
                    element={
                      <SecureRoute>
                        <BuildPlan />{' '}
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/build-own-plan"
                    element={
                      <SecureRoute>
                        <CustomPlan />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/setup-ready"
                    element={
                      <SecureRoute>
                        <SetUpReady />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/setup-ready/:featureSlug"
                    element={
                      <SecureRoute>
                        <SetUpReady />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/notifications"
                    element={
                      <SecureRoute>
                        <Notifications />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/21-day-trial"
                    element={

                      <TrialOffer />

                    }
                  />
                  {/*
                  Stripe checkout ka cancel_url. Iska route pehle tha hi nahi —
                  cancel karte hi blank page aata tha aur user /business-step me
                  ja phansta tha. Ab checkout se pehle stash kiye gaye path pe
                  wapas bhej deta hai.
                */}
                  <Route path="/payment-cancel" element={<PaymentCancel />} />
                  <Route path="/calinfo" element={<CalInfo />}></Route>
                  {/* <Route path="/" element={<Start />} /> */}
                  {/* Generic success page for all integrations (hubspot, zapier, make…) */}
                  <Route path="/integrations/:platform/success" element={<IntegrationThankYou />}></Route>
                  {/* Generic OAuth consent page (provider's popup lands here first) */}
                  <Route path="/oauth/:platform/consent" element={<IntegrationThankYou mode="consent" />}></Route>
                  <Route path="/signup" element={<SignUp />} />
                  <Route path="/edit-agent" element={<EditAgentNew />} />
                  <Route path="/edit-business-type" element={<EditBusinessType />} />
                  <Route path="/edit-services-offered" element={<EditServicesOffered />} />

                  <Route path="/edit-public-listing" element={<EditPublic />} />

                  <Route path="/edit-public" element={<EditPublic />} />
                  <Route path="/edit-business-detail" element={<EditBusinessDetail />} />
                  <Route path="/edit-language" element={<EditLanguage />} />
                  <Route path="/edit-gender" element={<EditGender />} />
                  <Route path="/edit-name-avtar" element={<EditNameAvtar />} />
                  <Route path="/usage-history" element={<UsageHistory />} />
                  <Route path="/manage-subscription" element={<ManageSubscription />} />
                  <Route
                    path="/plans"
                    element={
                      <SecureRoute>
                        <SubscriptionPlan />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/plan"
                    element={
                      <SecureRoute>
                        <Planss />
                      </SecureRoute>
                    }
                  />
                  <Route path="/message-plan" element={<MessagePlan />} />

                  <Route
                    path="/assign-number"
                    element={
                      <SecureRoute>
                        <AssignNumber />
                      </SecureRoute>
                    }
                  />
                  {/* Post-payment "Thank You" + Setup Progress interstitial.
                    PAYG/assign-number checkout success lands here first, then
                    "Continue" forwards to /assign-number (same params). */}
                  <Route
                    path="/payment-success"
                    element={
                      <SecureRoute>
                        <PaymentSuccess />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/details"
                    element={
                      <SecureRoute>
                        <Details />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/steps"
                    element={
                      <SecureRoute>
                        <Step />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/about-business"
                    element={
                      <SecureRoute>
                        <AboutBusiness />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/about-business-next"
                    element={
                      <SecureRoute>
                        <BusinessServicesNEXT />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/business-details"
                    element={
                      <SecureRoute>
                        <BusinessDetails />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/call-setting"
                    element={
                      <SecureRoute>
                        <CallSetting />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/public-agent-availability"
                    element={
                      <SecureRoute>
                        <PublicAgentAvailability />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/agent-detail"
                    element={
                      <SecureRoute>
                        <AgentDetail />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/business-locations"
                    element={
                      <SecureRoute>
                        <BusinessLocation />
                      </SecureRoute>
                    }
                  />

                  {/* Dashboard route disabled — fast-agent-detail is now the home page. */}

                  {/* <Route path="/home" element={<Home />} /> */}
                  <Route
                    path="/business-services"
                    element={
                      <SecureRoute>
                        <BusinessServices />
                      </SecureRoute>
                    }
                  />

                  {/* <Route path="/home" element={<Home />} /> */}
                  <Route
                    path="/ai-assistant"
                    element={
                      <SecureRoute>
                        <AiAssistant />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/rex-agent"
                    element={
                      <SecureRoute>
                        <RexAgent />
                      </SecureRoute>
                    }
                  />
                  {/* <Route path="/plans" element={<Plans />} /> */}
                  <Route
                    path="/checkout"
                    element={
                      <SecureRoute>
                        <SubscriptionFlow />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/calendar"
                    element={
                      <SecureRoute>
                        <Calendar />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/totalcall-list"
                    element={
                      <SecureRoute>
                        <TotalsCallsList />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/call-transfer"
                    element={
                      <SecureRoute>
                        <CallTransfer />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/call-details/:callId"
                    element={
                      <SecureRoute>
                        <CallDetails />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/live-monitoring/:callId"
                    element={
                      <SecureRoute>
                        <LiveMonitoringDashboard />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/live-monitoring/active-calls"
                    element={
                      <SecureRoute>
                        <ActiveCallsList />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/business-services"
                    element={
                      <SecureRoute>
                        <BusinessServices />
                      </SecureRoute>
                    }
                  />

                  <Route
                    path="/ai-assistant"
                    element={
                      <SecureRoute>
                        <AiAssistant />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/rex-agent"
                    element={
                      <SecureRoute>
                        <RexAgent />
                      </SecureRoute>
                    }
                  />
                  {/* <Route path="/plans" element={<Plans />} /> */}
                  <Route path="/checkout" element={<SubscriptionFlow />} />
                  <Route
                    path="/calendar"
                    element={
                      <SecureRoute>
                        <Calendar />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/edit-profile"
                    element={
                      <SecureRoute>
                        <EditProfile />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/your-business-Listing"
                    element={
                      <SecureRoute>
                        <BusinessListing />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/widget-guide"
                    element={
                      <SecureRoute>
                        <WidgetGuidePage />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/connect-calender"
                    element={
                      <SecureRoute>
                        <ConnectCalenderAPI />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/integrate-agent"
                    element={
                      <SecureRoute>
                        <IntegrateAgent />
                      </SecureRoute>
                    }
                  />
                  <Route path="/test-other" element={<Test />} />

                  <Route
                    path="/edit-profile"
                    element={
                      <SecureRoute>
                        <EditProfile />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/your-business-Listing"
                    element={
                      <SecureRoute>
                        <BusinessListing />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/widget-guide"
                    element={
                      <SecureRoute>
                        <WidgetGuidePage />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/connect-calender"
                    element={
                      <SecureRoute>
                        <ConnectCalenderAPI />
                      </SecureRoute>
                    }
                  />
                  <Route path="/own-plan" element={<OwnPlan />} />
                  <Route path="/own-custom-plan" element={<CustomPlan />} />

                  <Route
                    path="/agent-setup"
                    element={
                      <SecureRoute>
                        <AgentSetupHelp />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/documentation"
                    element={
                      <SecureRoute>
                        <Documentation />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/raise-tickets"
                    element={
                      <SecureRoute>
                        <RaiseTickets />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/create-ticket"
                    element={
                      <SecureRoute>
                        <CreateTicket />
                      </SecureRoute>
                    }
                  />

                  <Route
                    path="/integrate-agent"
                    element={
                      <SecureRoute>
                        <IntegrateAgent />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/call-recording"
                    element={
                      <SecureRoute>
                        <CallRecording />
                      </SecureRoute>
                    }
                  />

                  <Route
                    path="/add-file"
                    element={
                      <SecureRoute>
                        <Fileinfo />
                      </SecureRoute>
                    }
                  />

                  <Route
                    path="/notifications"
                    element={
                      <SecureRoute>
                        <NotificationView />
                      </SecureRoute>
                    }
                  />
                  {/* <Route
                  path="/agents/vip-numbers/:agentId"
                  element={
                    <SecureRoute>
                      <Add_VIP_Number />
                    </SecureRoute>
                  }
                /> */}

                  <Route
                    path="/business_hours/:businessId"
                    element={
                      <SecureRoute>
                        <Business_hours />
                      </SecureRoute>
                    }
                  />

                  <Route
                    path="/Business_hours"
                    element={
                      <SecureRoute>
                        <AgentSchedule />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/contacts"
                    element={
                      <SecureRoute>
                        <ContactsPage />
                      </SecureRoute>
                    }
                  />
                  {/* Integrations hub — opened from the More Setting menu.
                    UI-only catalogue (Shopify, Make.com, Zapier, HubSpot,
                    Clover) for now; per-platform connect flows wired later. */}
                  <Route
                    path="/integrations"
                    element={
                      <SecureRoute>
                        <IntegrationsPage />
                      </SecureRoute>
                    }
                  />
                  {/* MCP integration manager — Retell-style view. Add MCP servers
                    (Monday, HubSpot-MCP…), discover tools, and enable them per
                    agent. Open with nav-state { agentId } or it falls back to
                    the globally-selected agent (sessionStorage SelectAgentId). */}
                  <Route
                    path="/mcp-integration"
                    element={
                      <SecureRoute>
                        <McpIntegration />
                      </SecureRoute>
                    }
                  />

                  {/* Agent dialer — opened from the More Setting menu. Outbound
                    calls go out on the agent's own number; the carrier behind
                    it (Telnyx / Twilio / imported SIP) is resolved server-side. */}
                  <Route
                    path="/dialer"
                    element={
                      <SecureRoute>
                        <Dialer />
                      </SecureRoute>
                    }
                  />

                  <Route
                    path="/call_divert"
                    element={
                      <SecureRoute>
                        <CallDivert />
                      </SecureRoute>
                    }
                  />
                  <Route path="/connect-calender2" element={<ConnectCalenderV2 />} />

                  <Route path="/test-other" element={<Test />} />
                  <Route path="/thankyou/:id" element={<Thankyou />} />
                  <Route path="/cancel-payment" element={<CancelPage />} />
                  <Route path="/*" element={<RedirectHandler />} />
                  <Route path="/thankyou2" element={<Thankyou2 />} />
                  <Route path="/website-trial-success" element={<WebsiteTrialSuccess />} />

                  {/* Post-purchase wizard — only reachable when a paid
                    LP-demo visitor lands on Thankyou.jsx with the
                    `postPurchase=true` query flag. The shared Thankyou
                    page reads that flag and redirects here. The wizard
                    self-guards on `paymentDone=true` so it can't be
                    opened cold. */}
                  <Route
                    path="/post-purchase-setup"
                    element={<PostPurchaseSetup />}
                  />
                  {/*
                  Go Live wizard — fires after a free user purchases a phone
                  number from /get-number. Same 3-step component reuse pattern
                  as PostPurchaseSetup (Number / Forwarding / Triage). Entry
                  redirect from /get-number purchase success will be wired
                  when the post-purchase screen flow lands.
                */}
                  <Route
                    path="/go-live-setup"
                    element={<GoLiveWizard />}
                  />
                  {/*
                  Screen 14 — Contact Sync. Sits between GoLive triage
                  finish and the Sophia-is-Live celebration. Auto-pops
                  the "Help Sophia Recognise Your People" consent if
                  the user hasn't granted Google contacts.readonly,
                  otherwise renders ContactManager directly with a
                  Continue CTA.
                */}
                  <Route
                    path="/contact-sync"
                    element={
                      <SecureRoute>
                        <ContactSyncStep />
                      </SecureRoute>
                    }
                  />
                  {/*
                  Add-on intro nudges reached from the "Sophia is live"
                  dialog on /go-live-setup:
                    - /screen-your-calls → "Let {agent} screen your calls"
                      (Contact Access). Allow → /contact-sync, Skip →
                      /calendar-access.
                    - /calendar-access → "Let {agent} book your meetings"
                      (Calendar). Connect → Google OAuth, Skip →
                      /screen-your-calls.
                */}
                  <Route
                    path="/screen-your-calls"
                    element={
                      <SecureRoute>
                        <ScreenCallsIntro />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/calendar-access"
                    element={
                      <SecureRoute>
                        <CalendarBookingIntro />
                      </SecureRoute>
                    }
                  />
                  {/*
                  Screen 15 — Sophia is Live celebration. Stub for now;
                  Figma hasn't landed. Final flow lands them on the
                  dashboard via the CTA inside this component.
                */}
                  <Route
                    path="/go-live-celebration"
                    element={
                      <SecureRoute>
                        <GoLiveCelebration />
                      </SecureRoute>
                    }
                  />
                  <Route path="/number" element={<Number />} />
                  <Route path="/public-call/:token" element={<PublicCall />} />
                  <Route path="/delete-account" element={<Delete />} />
                  {/* Onboarding New Flow Route Start */}
                  <Route path="/" element={<Onboarding />} />
                  {/* Login/auth view — same Onboarding component, gated by
                    isLoginRoute (pathname === "/login"). Without this route,
                    navigating to /login (e.g. the splash "Skip") renders nothing. */}
                  <Route path="/login" element={<Onboarding />} />
                  <Route
                    path="/select-access"
                    element={
                      <SecureRoute>
                        <SelectAccess />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/fork"
                    element={
                      <SecureRoute>
                        <ForkScreen />
                      </SecureRoute>
                    }
                  />
                  {/* AppSumo redeem sits between OTP and onboarding, so it is
                    deliberately NOT wrapped in SecureRoute: that guard bounces
                    users with incomplete onboarding onward, which is precisely
                    the state every user is in when they reach this screen.
                    AppSumoRedeemPage does its own token check. */}
                  <Route path="/appsumo-redeem" element={<AppSumoRedeemPage />} />
                  {/* Reward screens: the referral hub and what feeds it. Behind
                    SecureRoute because every one of them is about this
                    account's own balance and referral link. */}
                  <Route
                    path="/rewards"
                    element={
                      <SecureRoute>
                        <RewardsHome />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/rewards/referrals"
                    element={
                      <SecureRoute>
                        <ReferralsEarnings />
                      </SecureRoute>
                    }
                  />
                  {/* Feedback and referral earnings merged into one history,
                    reached from the balance card on /rewards. */}
                <Route
                  path="/rewards/earnings"
                  element={
                    <SecureRoute>
                      <Earnings />
                    </SecureRoute>
                  }
                />
                <Route
                  path="/rewards/feedback"
                  element={
                    <SecureRoute>
                      <GiveFeedback />
                    </SecureRoute>
                  }
                />
                <Route
                  path="/fast-step"
                  element={
                    <SecureRoute>
                      <FastSetup />
                    </SecureRoute>
                  }
                />
                {/* Pounce agent detail — dashboard ke Pounce card se. */}
                <Route
                  path="/pounce-agent/:agentId"
                  element={
                    <SecureRoute>
                      <PounceAgentDetail />
                    </SecureRoute>
                  }
                />
                <Route
                  path="/add-lead"
                  element={
                    <SecureRoute fallback={null}>
                      <PounceAddLeadPage />
                    </SecureRoute>
                  }
                />
                  <Route
                  path="/bulk-upload"
                  element={
                    <SecureRoute fallback={null}>
                      <PounceBulkUploadPage />
                    </SecureRoute>
                  }
                />
                              <Route
                path="/bulk-upload/review"
                element={
                  <SecureRoute fallback={null}>
                    <PounceBulkUploadReviewPage />
                  </SecureRoute>
                }
              />
                  <Route
                path="/bulk-upload/success"
                element={
                  <SecureRoute fallback={null}>
                    <PounceBulkUploadSuccessPage />
                  </SecureRoute>
                }
              />
                {/* Pounce ki saari leads — agent page ke "New Leads" tile se. */}
                {/* Outbound Caller → Settings (footer ka Settings tab). */}
                <Route
                  path="/outbound-settings"
                  element={
                    <SecureRoute fallback={null}>
                      <OutboundSettings />
                    </SecureRoute>
                  }
                />
                {/* Outbound Caller → Settings → Usage & Billing. */}
                <Route
                  path="/outbound-billing"
                  element={
                    <SecureRoute fallback={null}>
                      <OutboundBilling />
                    </SecureRoute>
                  }
                />
                {/* Outbound Caller → Usage & Billing → Invoices (sirf us agent ki). */}
                <Route
                  path="/outbound-invoices"
                  element={
                    <SecureRoute fallback={null}>
                      <OutboundInvoices />
                    </SecureRoute>
                  }
                />
                {/* Pounce ki saari leads — agent page ke "New Leads" tile se. */}
                <Route
                  path="/leads"
                  element={
                    // fallback={null}: is page ka apna shimmer loader hai —
                    // SecureRoute ka teen-dot wala loader yahan nahi chahiye.
                    <SecureRoute fallback={null}>
                      <PounceLeadsPage />
                    </SecureRoute>
                  }
                />
                {/* Lead card → detail → transcript / qualification & activity. */}
                <Route
                  path="/leads/:leadId"
                  element={
                    <SecureRoute fallback={null}>
                      <PounceLeadDetail />
                    </SecureRoute>
                  }
                />
                  <Route
                    path="/rewards/earnings"
                    element={
                      <SecureRoute>
                        <Earnings />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/rewards/feedback"
                    element={
                      <SecureRoute>
                        <GiveFeedback />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/business-step"
                    element={
                      <SecureRoute>
                        <BusinessStep />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/fast-step"
                    element={
                      <SecureRoute>
                        <FastSetup />
                      </SecureRoute>
                    }
                  />
                  {/* Pounce agent detail — dashboard ke Pounce card se. */}
                  <Route
                    path="/pounce-agent"
                    element={
                      <SecureRoute>
                        <PounceAgentDetail />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/call-settings"
                    element={
                      <SecureRoute fallback={null}>
                        <PounceSettings />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/qualifying-questions"
                    element={
                      <SecureRoute fallback={null}>
                        <PounceQualifyingQuestions />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/pounce-agent/:agentId"
                    element={
                      <SecureRoute>
                        <PounceAgentDetail />
                      </SecureRoute>
                    }
                  />
                  {/* Pounce ki saari leads — agent page ke "New Leads" tile se. */}
                  <Route
                    path="/leads"
                    element={
                      // fallback={null}: is page ka apna shimmer loader hai —
                      // SecureRoute ka teen-dot wala loader yahan nahi chahiye.
                      <SecureRoute fallback={null}>
                        <PounceLeadsPage />
                      </SecureRoute>
                    }
                  />
                  {/* Lead card → detail → transcript / qualification & activity. */}
                  <Route
                    path="/leads/:leadId"
                    element={
                      <SecureRoute fallback={null}>
                        <PounceLeadDetail />
                      </SecureRoute>
                    }
                  />
                  {/* Pounce ki appointments — Booked Appts / Booking Appts /
                    footer ke Appointments se. Pages ka apna loader hai. */}
                  <Route
                    path="/pounce-appointments"
                    element={
                      <SecureRoute fallback={null}>
                        <PounceAppointmentsPage />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/leads/:leadId/transcript"
                    element={
                      <SecureRoute fallback={null}>
                        <PounceCallTranscript />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/leads/:leadId/activity"
                    element={
                      <SecureRoute fallback={null}>
                        <PounceLeadActivity />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/pounce-appointments/:id"
                    element={
                      <SecureRoute fallback={null}>
                        <PounceAppointmentDetail />

                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/editBusinessDetails"
                    element={
                      <SecureRoute>
                        <EditBusinessDetails />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/get-number"
                    element={
                      <SecureRoute>
                        <GetNumber />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/number-assign"
                    element={
                      <SecureRoute>
                        <NumberAssign />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/immediate-owner-ship"
                    element={
                      <SecureRoute>
                        <ImmediateOwnerShip />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/import-phone"
                    element={
                      <SecureRoute>
                        <ImportPhoneSip />
                      </SecureRoute>
                    }
                  />
                  {/*
                  ── A/B variant B ─────────────────────────────────────────
                  /fast-step ("Go Live with <agent>") se yahan aate hain jab
                  user variant B me ho:
                    /receptionist-number → /agent-live
                  Variant A wahi purana /recommended-plan pe jaata hai.
                  Variant ka faisla FastSetup ke handleSeePlans me hota hai;
                  ye routes khud gate nahi karte, taaki QA ?ab=B lagakar
                  seedha bhi khol sake.

                  Path SINGLE-segment hona zaroori hai (/b/... nahi): shared
                  AnimatedButton apna background <img src="svg/..."> RELATIVE
                  deta hai, to nested path pe wo /b/svg/... ban ke 404 ho jaata
                  aur button ki jagah broken image dikhti hai.
                */}
                  <Route
                    path="/receptionist-number"
                    element={
                      <SecureRoute>
                        <ReceptionistNumber />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/agent-live"
                    element={
                      <SecureRoute>
                        <AgentLive />
                      </SecureRoute>
                    }
                  />
                  {/*
                  Asli phone call ke BAAD ki screen — sirf tab jab call 25 sec ya
                  usse lambi ho (chhoti call seedha /21-day-trial pe jaati hai).
                  Yahan tak socket ka phone_call_completed event ya /agent-live ka
                  app-kill fallback bhejta hai, callId + agentId ke saath.
                */}
                  <Route
                    path="/call-summary"
                    element={
                      <SecureRoute>
                        <CallSummary />
                      </SecureRoute>
                    }
                  />
                  {/*
                  "How Customers Reach <agent>" — variant B ka rasta chunne wala
                  screen. Dono raaste GoLiveWizard (/go-live-setup) ke hi steps
                  hain, isliye koi component dobara nahi banaya:
                    Keep existing number → wizard ka Carrier step (2)
                    Use agent's number   → wizard ka Triage step (4)
                */}
                  <Route
                    path="/setup-path"
                    element={
                      <SecureRoute>
                        <SetupPath />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/select-carrier"
                    element={
                      <SecureRoute>
                        <SelectCarrier />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/forward-instructions"
                    element={
                      <SecureRoute>
                        <ForwardInstructions />
                      </SecureRoute>
                    }
                  />
                  <Route
                    path="/fast-agent-detail"
                    element={
                      <SecureRoute>
                        <FastAgentDetails />
                      </SecureRoute>
                    }
                  />
                        <Route
                  path="/need-help-tickets"
                  element={
                    <SecureRoute>
                      <NeedHelpTicketsPage />
                    </SecureRoute>
                  }
                />
                  <Route path="/the-comparison" element={<TheComparison />} />
                  <Route path="/the-solution" element={<TheSolution />} />
                  <Route
                    path="/recommended-plan"
                    element={
                      <SecureRoute>
                        <RecommendedPlan />
                      </SecureRoute>
                    }
                  />
                  {/* Onboarding New Flow Route End */}
                </Routes>
              </ErrorBoundary>
            </div>
            {/* </BrowserRouter> */}
          </PreventPullToRefresh>
        </div>
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
    </GlobalCallProvider>
  );
}
export default App;

// modal close modal open
